import { render, staticRenderFns } from "./LinkWeappBtn.vue?vue&type=template&id=7b2b7c6c&scoped=true&"
import script from "./LinkWeappBtn.vue?vue&type=script&lang=js&"
export * from "./LinkWeappBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b7c6c",
  null
  
)

export default component.exports